import { useRef } from 'react';

import UtilityMenuMobile from './UtilityMenu/Mobile.jsx';
import LdsIcon from '../LdsIcon/index.jsx';
import LdsLillyLogo from '../LdsLillyLogo/index.jsx';

export default function MobilePanel({
  // Utility menu props
  showUtilityMenu,
  showUtilityLogo,
  contactLilly,
  languageSelector,
  utilityMenuLinks,
  utilityMenuAriaLabel,
  utilityMenuCustomLinkItems,
  utilityMenuCustomLinkItemsPosition,
  // Logo & hamburglar
  customLogo,
  lillyLogo,
  labelCloseMenu,
  //
  topNavAriaLabel,
  isMobileMenuOpen,
  toggleMobileMenu,
  children,
}) {
  const closeMenuButtonRef = useRef(null);
  // const openMenuButtonRef = useRef(null);

  return (
    <div
      className="lds-header-menu-container  header-mobile"
      inert={!isMobileMenuOpen ? '' : null}
    >
      <nav
        aria-label={topNavAriaLabel || 'Primary'}
        className={`lds-header-menu-wrapper ${
          isMobileMenuOpen ? 'toggle-mobile-menu' : ''
        }`}
      >
        {/* Top bar with logo and close button */}
        <div className="header-mobile-panel-bar lds-header-logo-wrapper">
          {customLogo || <LdsLillyLogo {...lillyLogo} />}

          <button
            ref={closeMenuButtonRef}
            id="lds-close-menu-button"
            data-testid="lds-close-menu-button"
            onClick={toggleMobileMenu}
            type="button"
            className="lds-button-base lds-header-toggle toggleMobileMenu"
          >
            <LdsIcon decorative name="X" inline className="lds-hamburger-menu-icon" />
            <span className="lds-header-toggle-text">{labelCloseMenu || 'Close'}</span>
          </button>
        </div>

        {/* Scroll container with nav items */}
        <div className="lds-header-menu-scroll-container">
          <ul
            className="lds-header-menu lds-header-menu-primary"
          >

            {children}

            { showUtilityMenu
              && <UtilityMenuMobile
                showUtilityLogo={showUtilityLogo}
                contactLilly={contactLilly}
                languageSelector={languageSelector}
                utilityMenuLinks={utilityMenuLinks}
                utilityMenuAriaLabel={utilityMenuAriaLabel}
                customLinkItems={utilityMenuCustomLinkItems}
                customLinkItemsPosition={utilityMenuCustomLinkItemsPosition}
                toggleMobileMenu={toggleMobileMenu}
              />
            }
          </ul>
        </div>
      </nav>
    </div>
  );
}
